var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { space, display, themeGet } from 'styled-system';
import dayjs from 'dayjs';
import { withLocale, LocaleConsumer, } from '../../common/providers/LocaleProvider';
import { Text } from '../../common/components/Text';
import { LinkButton } from '../../common/components/Link';
import { Grid, GridItem } from '../../common/components/Grid';
import dispatchTrackingEvent from '../../common/tracking/dispatchTrackingEvent';
import cookieStorage from '../../common/CookieStorage';
import deviceDetector from '../../common/DeviceDetector';
import closeIcon from '../../common/assets/icons/close.svg';
import home24Icon from '../../common/assets/icons/home-24-icon.svg';
var SmartBannerGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n\n  background-image: linear-gradient(\n    to left,\n    ", ",\n    ", "\n  );\n"], ["\n  ", ";\n\n  background-image: linear-gradient(\n    to left,\n    ", ",\n    ", "\n  );\n"])), display, themeGet('colors.gray.13'), themeGet('colors.pink.0'));
SmartBannerGrid.defaultProps = {
    display: ['flex', null, 'none'],
};
var Container = styled(GridItem)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 56px;\n  flex: none;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  height: 56px;\n  flex: none;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));
var CloseButton = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n\n  height: ", "px;\n"], ["\n  ", ";\n\n  height: ", "px;\n"])), space, themeGet('space.3'));
var CloseIcon = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n  max-width: ", "px;\n  max-height: ", "px;\n"], ["\n  width: ", "px;\n  height: ", "px;\n  max-width: ", "px;\n  max-height: ", "px;\n"])), themeGet('space.3'), themeGet('space.3'), themeGet('space.3'), themeGet('space.3'));
var MiddleContent = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n\n  display: flex;\n  max-height: 40px;\n  align-items: center;\n"], ["\n  ", ";\n\n  display: flex;\n  max-height: 40px;\n  align-items: center;\n"])), space);
var Home24Icon = styled.img(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", ";\n\n  height: 40px;\n  max-width: 40px;\n  max-height: 40px;\n"], ["\n  ", ";\n\n  height: 40px;\n  max-width: 40px;\n  max-height: 40px;\n"])), space);
var BannerText = styled(Text)(templateObject_7 || (templateObject_7 = __makeTemplateObject([""], [""])));
BannerText.defaultProps = {
    m: 0,
    as: 'p',
    fontSize: 1,
    lineHeight: '20px',
};
var InstallButton = styled(LinkButton)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  flex: none;\n  display: flex;\n  box-shadow: none;\n  font-weight: normal;\n"], ["\n  flex: none;\n  display: flex;\n  box-shadow: none;\n  font-weight: normal;\n"])));
export var DAYS_SMART_BANNER_WILL_NOT_APPEAR = 7;
export var ADJUST_URL = {
    ANDROID: 'https://app.adjust.io/tt125s',
    IOS: 'https://app.adjust.io/jpspnl',
};
// The logic for this method is available on https://home24.atlassian.net/browse/CNN-474
export var extractTrackingParams = function (href) {
    var url = new URL(href);
    var utmSource = url.searchParams.get('utm_source');
    if (utmSource) {
        return {
            campaign: utmSource,
            adgroup: '',
            creative: '',
        };
    }
    var utmMedium = url.searchParams.get('utm_medium');
    var gclid = url.searchParams.get('gclid');
    if (utmMedium || gclid) {
        return __assign(__assign(__assign({ campaign: '' }, (utmMedium && { adgroup: utmMedium })), (gclid && { adgroup: gclid })), { creative: '' });
    }
    var utmCampaign = url.searchParams.get('utm_campaign');
    var utmContent = url.searchParams.get('utm_content');
    if (utmCampaign || utmContent) {
        return __assign({ campaign: '', adgroup: '' }, (utmCampaign && utmContent
            ? { creative: utmCampaign + "|" + utmContent }
            : utmCampaign && !utmContent
                ? { creative: utmCampaign + "|" }
                : !utmCampaign && utmContent
                    ? { creative: "|" + utmContent }
                    : {}));
    }
    var efId = url.searchParams.get('ef_id');
    if (efId) {
        return {
            campaign: 'google_ef',
            adgroup: '',
            creative: efId,
        };
    }
    return {
        campaign: 'direct',
        adgroup: '',
        creative: '',
    };
};
export var getDeepLink = function (_a) {
    var _b = _a === void 0 ? {} : _a, language = _b.language, region = _b.region;
    return language && region ? "home24://" + language + "_" + region + "/n?id=100" : '';
};
export var getVoucher = function (_a) {
    var region = (_a === void 0 ? {} : _a).region;
    return region ? "H24APP-" + region : '';
};
export var buildSmartBannerUrl = function (_a) {
    var l10n = _a.l10n;
    var isMobileAndroid = deviceDetector.isMobileAndroid;
    if (!window) {
        return { url: '#' };
    }
    var urlHref;
    var url = new URL(isMobileAndroid() ? ADJUST_URL.ANDROID : ADJUST_URL.IOS);
    var href = window.location.href;
    var _b = extractTrackingParams(href), campaign = _b.campaign, adgroup = _b.adgroup, creative = _b.creative;
    url.searchParams.set('campaign', campaign);
    url.searchParams.set('adgroup', adgroup);
    url.searchParams.set('creative', creative);
    url.searchParams.set('deep_link', getDeepLink(l10n));
    urlHref = url.href;
    if (isMobileAndroid()) {
        urlHref += encodeURIComponent("&voucher=" + getVoucher(l10n));
    }
    return { url: urlHref };
};
/**
 * The Smart Banner component will only be rendered if all the rules below are satisfied:
 *
 * 1) If the browser has a Mobile or Tablet viewport.
 * 2) If the user agent is Android or iOS.
 * 3) If the [userClosedBanner] cookie exists.
 */
var CommonSmartBanner = function (_a) {
    var l10n = _a.l10n;
    var _b = __read(useState(false), 2), showBanner = _b[0], setShowBanner = _b[1];
    var _c = __read(useState(''), 2), buttonUrl = _c[0], setButtonUrl = _c[1];
    useEffect(function () {
        var shouldShowSmartBanner = !cookieStorage.getIsSmartBannerClosed();
        var isMobileAndroid = deviceDetector.isMobileAndroid, isMobileIOS = deviceDetector.isMobileIOS;
        if (shouldShowSmartBanner) {
            if (isMobileAndroid() || isMobileIOS()) {
                var url = buildSmartBannerUrl({
                    l10n: l10n,
                }).url;
                setButtonUrl(url);
                setShowBanner(true);
            }
        }
    }, []);
    var onCloseClick = function (event) {
        event.preventDefault();
        // After you close Smart Banner, it will not appear again for 7 days.
        cookieStorage.closeSmartBanner({
            path: '/',
            expires: new Date(dayjs()
                .add(DAYS_SMART_BANNER_WILL_NOT_APPEAR, 'day')
                .valueOf()),
        });
        // Dispatch close button tracking event
        dispatchTrackingEvent({
            event: 'smartBannerTracking',
            eventCategory: 'button',
            eventAction: 'click',
            eventData: {
                placement: 'closeButton',
                iconIdentifier: 'close',
            },
        });
        setShowBanner(false);
    };
    var onClickInstall = React.useCallback(function (event) {
        var element = event.currentTarget;
        dispatchTrackingEvent({
            event: 'smartBannerTracking',
            eventCategory: 'link',
            eventAction: 'click',
            eventData: {
                placement: 'installButton',
                label: element.innerText || element.textContent,
                labelIdentifier: element.getAttribute('data-testid'),
                targetUrl: element.href,
            },
        });
    }, []);
    return showBanner ? (React.createElement(SmartBannerGrid, { "data-testid": "smart-banner-container" },
        React.createElement(LocaleConsumer, null, function (locale) { return (React.createElement(Container, { px: 0, py: 2 },
            React.createElement(CloseButton, { "data-testid": "close-button", px: 2, py: "12px", tabIndex: "0", onClick: onCloseClick, onKeyDown: function (event) {
                    if (event.key === ' ' || event.key === 'Enter') {
                        onCloseClick(event);
                    }
                } },
                React.createElement(CloseIcon, { src: closeIcon, role: "presentation" })),
            React.createElement(MiddleContent, { pl: 2, pr: 4 },
                React.createElement(Home24Icon, { pr: 2, src: home24Icon, role: "presentation" }),
                React.createElement(BannerText, { dangerouslySetInnerHTML: {
                        __html: locale.r(locale.t('smart_banner_text'), {
                            discount: "<b>" + locale.t('smart_banner_discount') + "</b>",
                        }),
                    } })),
            React.createElement(InstallButton, { "data-testid": "install-button", href: buttonUrl, onClick: onClickInstall }, locale.t('smart_banner_button')))); }))) : null;
};
export default withLocale(CommonSmartBanner);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
